import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import ProductList from './components/products/ProductList';
import ProductDetail from './components/products/ProductDetail';
import CreateProduct from './components/products/CreateProduct';
import EditProduct from './components/products/EditProduct';
import MyProducts from './components/products/MyProducts';
import Profile from './components/profile/Profile';
import MessagesPage from './components/messages/MessagesPage';
import Impressum from './components/pages/Impressum';
import Datenschutz from './components/pages/Datenschutz';
import AdminDashboard from './components/admin/AdminDashboard';
import SessionTimeout from './components/auth/SessionTimeout';
import Tracking from './components/tracking/Tracking';
import MyFavorites from './components/products/MyFavorites';
import SellerProfile from './components/products/SellerProfile';
import ClubPage from './components/pages/ClubPage';
import CategoryPage from './components/pages/CategoryPage';
import { FavoritesProvider } from './components/auth/FavoritesContext';
import OnboardingPopup from './components/common/OnboardingPopup';

// Komponente zum Umleiten von Admin-Benutzern
const AdminRedirect = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Wenn der Benutzer ein Admin ist und sich nicht bereits im Admin-Bereich befindet
    if (user && isAdmin && !location.pathname.startsWith('/admin')) {
      navigate('/admin');
    }
  }, [user, isAdmin, navigate, location]);

  return null; // Render nichts
};

function App() {
  return (
    <AuthProvider>
      <FavoritesProvider>
      {/* Tracking-Komponente */}
      <Tracking />
      
      <BrowserRouter>
        {/* Admin-Weiterleitung */}
        <AdminRedirect />
        
        {/* SessionTimeout innerhalb des BrowserRouter platzieren */}
        <SessionTimeout timeoutMinutes={30} />
        <OnboardingPopup />
        
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<ProductList showHero={true} />} />
            <Route path="/products" element={<ProductList showHero={false} />} />
            <Route path="/products/create" element={<CreateProduct />} />
            <Route path="/products/edit/:id" element={<EditProduct />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/my-products" element={<MyProducts />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/favorites" element={<MyFavorites />} />
            <Route path="/seller/:id" element={<SellerProfile />} />
            <Route path="/club/:name" element={<ClubPage />} />
            <Route path="/kategorie/:name" element={<CategoryPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </FavoritesProvider>
    </AuthProvider>
  );
}

export default App;